import actions from '@/store/modules/synthetics/secretManager/secretManager.actions';
import getters from '@/store/modules/synthetics/secretManager/secretManager.getters';
import mutations from '@/store/modules/synthetics/secretManager/secretManager.mutation';
import { SortingParams } from '@/store/modules/synthetics/tokenManager/tokenManager.store'
import { defaultSortingParams } from '@/components/SM/SecretManager/sm.secret.types';
export interface State {
  searchSecretName: String,
  secretId: String,
  secretName: String,
  isSecretDeleteActive: Boolean,
  secretPageNum: Number,
  secretSortParams: SortingParams,
  isSecretFormOpen: Boolean
}

const initialState: State = {
  searchSecretName: '',
  secretId: '',
  secretName: '',
  isSecretDeleteActive: false,
  secretPageNum: 1,
  secretSortParams: {
    ...defaultSortingParams
  },
  isSecretFormOpen: false
}

export default {
  namespaced: true,
  state: initialState,
  actions,
  getters,
  mutations
};
